import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. Todo está explicado desde cero.'
  }, {
    q: '¿Necesito máquinas especiales?',
    a: 'No. Solo herramientas básicas.'
  }, {
    q: '¿Cuánto dinero necesito para comenzar?',
    a: 'Muy poco comparado con otros emprendimientos.'
  }, {
    q: '¿Puedo vender mis trabajos?',
    a: 'Sí. El Tomo 2 está diseñado para eso.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso digital inmediato.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Tenés garantía de 7 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-center text-brand-dark mb-5" data-id="element-81">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5" data-id="element-82">
          {faqs.map((faq, i) => <div key={i} className={`border rounded-xl overflow-hidden transition-colors ${openIndex === i ? 'border-brand-pink bg-brand-pink/5' : 'border-gray-200 bg-white'}`} data-id="element-83">
              <button className="w-full text-left px-4 py-3 flex items-center justify-between font-bold text-brand-dark text-sm md:text-base focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-84">
                <span data-id="element-85">{faq.q}</span>
                <ExpandMoreIcon className={`transition-transform duration-300 ${openIndex === i ? 'rotate-180 text-brand-pink' : 'text-gray-400'}`} data-id="element-86" />
              </button>

              <div className={`px-4 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-40 pb-3 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-87">
                <p className="text-brand-text text-sm md:text-base" data-id="element-88">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}